import React, { useState, useEffect, useRef } from "react";
import authStorage from "../../utils/authStorage";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import Skeleton from "react-loading-skeleton";
import './PopUp.css';
import adminDumny from "../../assets/images/adminDumny.svg";
const EditProfilebyUsrPopUp = ({ handlePopUp }) => {
  const [loading, setLoading] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [error, setError] = useState('');
  const[buthide,setButhide]=useState(false);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    age: "",
    gender: "",
    weight: "",
    height: ""
  });
  const [userForm, setUserForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    age: "",
    gender: "",
    weight: "",
    height: ""
  });
  const [profileImage, setProfileImage] = useState(null);

  // --- Leaderboard settings (client feedback 2026-09-17) --------------------
  // Held OUTSIDE `userForm` on purpose. `userForm` is spread straight into the
  // Update POST, so folding consent in there would re-post it on every ordinary
  // profile save -- stamping `leaderboardOptInAt` and marking consent as
  // "chosen" for someone who never touched the toggle. Consent has to be an
  // explicit act, so it gets its own state and its own save.
  const [optIn, setOptIn] = useState(true);
  const [displayName, setDisplayName] = useState("");

  // What the server had when the form opened. Used so Update sends a leaderboard
  // key ONLY when it actually changed -- see the note on updateProfile.
  const loadedPrefs = useRef({ optIn: true, displayName: "" });
  const [imageURL, setImageURL] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getProfile();
    fetchProfileImage();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserForm({
      ...userForm,
      [name]: value
    });
  };

  const handleGenderChange = (e) => {
    setUserForm({
      ...userForm,
      gender: e.target.value
    });
  };

  const handleImageChange = (e) => {
    setProfileImage(e.target.files[0]);
  };

  const updateProfile = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const fullName = `${userForm.firstName} ${userForm.lastName}`;

    // GET /user/profile returns the leaderboard settings too, so they arrive in
    // `userForm` -- but a stale copy. Strip them and re-add from the dedicated
    // state, which is what the controls actually bind to.
    const {
      leaderboardOptIn: _staleOptIn,
      leaderboardOptInChosen: _staleChosen,
      leaderboardDisplayName: _staleName,
      ...profileFields
    } = userForm;

    // Send a leaderboard key ONLY when it changed. `leaderboardOptIn` is
    // tri-state on the server (undefined = never chosen), and posting it on
    // every save would stamp a consent decision for someone who only came here
    // to edit their weight. Sending it just when the toggle actually moved keeps
    // "never chosen" intact, which is what lets the product switch between
    // opt-out and strict opt-in later without a migration.
    const prefPatch = {};
    if (optIn !== loadedPrefs.current.optIn) prefPatch.leaderboardOptIn = optIn;
    if (displayName !== loadedPrefs.current.displayName) prefPatch.leaderboardDisplayName = displayName;

    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/profile`,
      method: 'POST',
      data: {
        ...profileFields,
        ...prefPatch,
        name: fullName
      }
    }).then((res) => {
      setLoading(false);
      getProfile();
      handlePopUp(0)
      if(res.data.data.name!==authStorage.getItem('user-name')){
        authStorage.setItem("user-name",res.data.data.name)
      }
    }).catch((err) => {
      if (err?.response?.data?.message) {
        setError(err?.response?.data?.message);
        setTimeout(() => {
          setError("");
        }, 3000);
      }
      setLoading(false);
    });
  };

  const uploadImage = (e) => {
    e.preventDefault();
    if (!profileImage) return;

    setLoading(true);

    const formData = new FormData();
    formData.append('profileImage', profileImage);

    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
        'Content-Type': 'multipart/form-data'
      },
      url: `${BASE_URL}/user/profile/uploadImage`,
      method: 'POST',
      data: formData
    }).then((res) => {
      setLoading(false);
      fetchProfileImage();
      setButhide(false)
    }).catch((err) => {
      if (err?.response?.data?.message) {
        setError(err?.response?.data?.message);
        setButhide(false)
        setTimeout(() => {
          setError("");
        }, 3000);
      }
      setLoading(false);
    });
  };

  const getProfile = () => {
    setError("");
    setProfileLoading(true);
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/profile`,
      method: 'GET'
    }).then((res) => {
      const userData = res?.data?.data;
      const [firstName, lastName] = userData.name.split(" ");
      setUser({
        ...userData,
        firstName,
        lastName
      });
      setUserForm({
        ...userData,
        firstName,
        lastName
      });
      // The API sends the RESOLVED participation boolean, so a member who has
      // never chosen sees the product's current default rather than a blank.
      const loadedOptIn = userData?.leaderboardOptIn !== false;
      const loadedName = userData?.leaderboardDisplayName || "";
      setOptIn(loadedOptIn);
      setDisplayName(loadedName);
      loadedPrefs.current = { optIn: loadedOptIn, displayName: loadedName };
      setProfileLoading(false);
    }).catch((err) => {
      if (err?.response?.data?.message) {
        setError(err?.response?.data?.message);
        setTimeout(() => {
          setError("");
        }, 3000);
      }
      setProfileLoading(false);
    });
  };

  const fetchProfileImage = () => {
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/profile/image`,
      method: 'GET',
      responseType: 'blob'
    }).then((res) => {
      const url = URL.createObjectURL(res.data);
      setImageURL(url)
    }).catch((err) => {
      if (err?.response?.data?.message) {
        setError(err?.response?.data?.message);
        setTimeout(() => {
          setError("");
        }, 3000);
      }
    });
  };

  const handleProfilePictureChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImageURL(URL.createObjectURL(e.target.files[0]));
      setButhide(true);
    }
  };

  return (
    <>
      <div className="edit-user-page sign-in-default">
        <div className="container">
          <span className="close-btn" onClick={() => { handlePopUp(0) }} >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
          <div className="form-box-outer">
            <div className="form-box">
              {/* <h1>Edit Profile Page</h1> */}
              {profileLoading ? (
                <Skeleton count={5} className="mt-10" />
              ) : (
                <form onSubmit={updateProfile}>
                  <div className="input-box col-span-2 profile-box">
                    <div className="flex items-center gap-4 justify-center ">
                      <div className="relative" id="file">
                        {imageURL ? <img src={imageURL} alt="Profile" />:<img src={adminDumny} alt="Profile" />}
                        <div className="flex">
                          <input
                            type="file"
                            onChange={(e) => {
                              handleImageChange(e);
                              handleProfilePictureChange(e);
                            }}
                          />
                          <button onClick={uploadImage} className={`py-1 px-3 rounded-lg text-white text-xs bg-[#2995F7] border-none ${buthide  ? "" : "hidden"}`}>Confirm</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="input-box">
                    <div className="heading">First Name</div>
                    <input
                    className="placeholder:text-black"
                      value={userForm.firstName}
                      onChange={handleInputChange}
                      id="firstName"
                      name="firstName"
                      type="text"
                      placeholder="Name"
                    />
                  </div>
                  <div className="input-box">
                    <div className="heading">Last Name</div>
                    <input
                    className="placeholder:text-black"
                      value={userForm.lastName}
                      onChange={handleInputChange}
                      id="lastName"
                      name="lastName"
                      type="text"
                      placeholder="Last Name"
                    />
                  </div>
                  <div className="input-box">
                    <div className="heading">Age</div>
                    <input
                    className="placeholder:text-black"
                      value={userForm.age}
                      onChange={handleInputChange}
                      id="age"
                      name="age"
                      type="number"
                      placeholder="age "
                    />
                     <span className="input-after">year</span>
                  </div>
                  <div className="input-box radio-box">
                    <div className="heading">Gender</div>
                    <div>
                      <label>
                        <input
                        className="placeholder:text-black"
                          type="radio"
                          name="gender"
                          value="male"
                          checked={userForm.gender === "male"}
                          onChange={handleGenderChange}
                        />
                        Male
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="gender"
                          value="female"
                          checked={userForm.gender === "female"}
                          onChange={handleGenderChange}
                        />
                        Female
                      </label>
                    </div>
                  </div>
                  <div className="input-box">
                    <div className="heading">Weight</div>
                    <input
                    className="placeholder:text-black"
                      value={userForm.weight}
                      onChange={handleInputChange}
                      id="weight"
                      name="weight"
                      type="text"
                      placeholder="Weight "
                    />
                      <span className="input-after">Kg</span>
                  </div>
                  <div className="input-box">
                    <div className="heading">Height</div>
                    <input
                    className="placeholder:text-black"
                      value={userForm.height}
                      onChange={handleInputChange}
                      id="height"
                      name="height"
                      type="number"
                      placeholder="Height "
                      />
                      <span className="input-after">cm</span>
                  </div>
                  {/* --- Leaderboard settings ---------------------------------
                      `col-span-2` because the surrounding <form> is a 2-column
                      CSS grid (PopUp.css) -- the avatar block uses the same
                      idiom. Without it this section was squeezed into one
                      column and pushed the Update/Cancel row up alongside it.

                      Inside the form but NOT part of the Update button: both
                      controls save themselves, so consent is always an explicit
                      act and cannot ride along on an unrelated profile edit.

                      NOTE this project loads only `@tailwind utilities`
                      (src/index.css) -- there is no preflight, so every bare
                      button keeps Chrome's default border and button face. That
                      is why the switch and the save button both spell out
                      `border-0` and `appearance-none`. Layout uses Tailwind
                      classes rather than inline styles so it can collapse to one
                      column on mobile, matching the form's own breakpoint. */}
                  <div className="input-box col-span-2 !block mt-2 border-0 border-t border-solid border-gray-200 pt-5">
                    <div className="mb-4">
                      <div className="text-base font-semibold text-gray-900">Leaderboard</div>
                      <div className="mt-0.5 text-xs text-gray-500">
                        Choose whether you appear on the leaderboard, and the name other members
                        see. These are saved with Update, like the rest of this form.
                      </div>
                    </div>

                    <div className="grid grid-cols-1 gap-y-5 md:grid-cols-2 md:gap-x-10">
                      {/* Participation */}
                      <div>
                        <div className="mb-2 text-sm font-medium text-gray-800">
                          Show me on the leaderboard
                        </div>
                        <div className="flex items-start gap-3">
                          <button
                            type="button"
                            role="switch"
                            aria-checked={optIn}
                            aria-label="Show me on the leaderboard"
                            onClick={() => setOptIn((v) => !v)}
                            className="border-0 appearance-none shrink-0"
                            style={{
                              position: 'relative', width: '44px', height: '24px', marginTop: '1px',
                              borderRadius: '999px', cursor: 'pointer',
                              background: optIn ? '#10b981' : '#9ca3af',
                              transition: 'background-color .15s ease',
                            }}
                          >
                            <span style={{
                              position: 'absolute', top: '3px', left: optIn ? '23px' : '3px',
                              width: '18px', height: '18px', borderRadius: '999px', background: '#fff',
                              transition: 'left .15s ease',
                            }} />
                          </button>
                          <p className="text-xs leading-relaxed text-gray-500">
                            {optIn
                              ? "Your rank and activity totals are visible to other members."
                              : "You are hidden from every leaderboard. Your own Summary and Goals page is unaffected."}
                          </p>
                        </div>
                      </div>

                      {/* Display name */}
                      <div>
                        <div className="mb-2 flex items-baseline justify-between gap-2">
                          <span className="text-sm font-medium text-gray-800">Display name</span>
                          <span className="text-xs tabular-nums text-gray-400">{displayName.length}/30</span>
                        </div>
                        <input
                          id="leaderboardDisplayName"
                          aria-label="Display name"
                          className="placeholder:text-gray-400 w-full"
                          type="text"
                          value={displayName}
                          maxLength={30}
                          onChange={(e) => setDisplayName(e.target.value)}
                          placeholder={user?.name || 'Your name'}
                        />
                        <p className="mt-2 text-xs leading-relaxed text-gray-500">
                          Shown on the leaderboard instead of your real name. Leave blank to use{' '}
                          <span className="text-gray-700">{user?.name || 'your name'}</span>.
                        </p>
                      </div>
                    </div>

                  </div>

                  {/* `col-span-2` + `justify-end`: these belong to the whole form, so
                      they sit on their own row at the bottom rather than in the right
                      column level with the Leaderboard section. */}
                  <div className="submit-box col-span-2 mt-6 justify-end border-0 border-t border-solid border-gray-200 pt-5">
                    <button type="submit">Update</button>
                    <button type="button" className="cancel-btn" onClick={() => handlePopUp(0)}>Cancel</button>
                  </div>
                  {loading && <Skeleton count={5} />}
                  {error && <div className="error-message">{error}</div>}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfilebyUsrPopUp;


